/**
 * @generated SignedSource<<95e01287207b3c03f02d65801f7c1546>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarBlurbShipping_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedShippingInfoWrapper_user">;
  readonly " $fragmentType": "PdpRespSidebarBlurbShipping_user";
};
export type PdpRespSidebarBlurbShipping_user$key = {
  readonly " $data"?: PdpRespSidebarBlurbShipping_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarBlurbShipping_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarBlurbShipping_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedShippingInfoWrapper_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "6702fb18f686042852bdbbdf3ffc22a5";

export default node;
